import { useState, useEffect } from "react";
import {
  ShimmeredDetailsList,
  SelectionMode,
  mergeStyles,
  IDetailsListProps,
  DetailsHeader,
  IColumn,
} from "@fluentui/react";
import useWindowDimensions from "@/utils/windowsUtils";

interface Props {
  numberOfColumns: number;
}

const ShimmerList = (props: Props) => {
  const [shimmerColumns, setShimmerColumns] = useState<IColumn[]>();
  const { width } = useWindowDimensions();

  useEffect(() => {
    let columns = [];
    const columnWidth = Math.max(120, width / props.numberOfColumns - 28);
    for (let i = 0; i < props.numberOfColumns; i++) {
      columns.push({
        key: `column${i}`,
        name: "",
        fieldName: "",
        width: columnWidth,
        minWidth: columnWidth,
        maxWidth: columnWidth,
      });
    }
    setShimmerColumns(columns);
  }, [props.numberOfColumns, width]);

  const listStyle = mergeStyles({
    position: "relative",
    overflowX: "hidden",
  });

  const headerStyles = {
    root: {
      selectors: {
        ".ms-DetailsHeader-cellName": {
          fontWeight: "bold",
          fontSize: 13,
          marginLeft: 15,
        },
      },
      borderBottom: "1px solid #ddd",
      paddingTop: 1,
    },
  };

  const onRenderDetailsHeader: IDetailsListProps["onRenderDetailsHeader"] = (
    props
  ) => {
    if (props) {
      return <DetailsHeader {...props} styles={headerStyles} />;
    }
    return null;
  };

  return (
    <>
      <div style={{ overflowX: "hidden", width: "100%" }}>
        <ShimmeredDetailsList
          setKey="items"
          items={[]}
          className={listStyle}
          columns={shimmerColumns}
          selectionMode={SelectionMode.none}
          enableShimmer={true}
          ariaLabelForShimmer="Content is being fetched"
          ariaLabelForGrid="Item details"
          onRenderDetailsHeader={onRenderDetailsHeader}
          shimmerLines={10}
        />
      </div>
    </>
  );
};

export default ShimmerList;
